// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.3_webpack@5.105.2_esbuild@0.28.1_postcss@8.5.23_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-shell {
  min-height: 100vh;
  background: radial-gradient(120% 120% at 20% 20%, #f5f7fb, #e7ecf7 55%, #dfe6f5);
  color: #1b2433;
  display: grid;
  place-items: center;
  padding: 48px 16px;
}

.auth-hero {
  text-align: center;
  margin-bottom: 24px;
  max-width: 720px;
}

.auth-hero__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.18);
  color: #1d4ed8;
  padding: 8px 14px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}

.auth-hero__title {
  margin: 12px 0 8px;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.auth-hero__subtitle {
  margin: 0;
  color: #4b5563;
  font-size: 15px;
}

.auth-panel {
  width: min(960px, 100%);
  background: #ffffff;
  border: 1px solid rgba(12, 20, 39, 0.08);
  border-radius: 20px;
  box-shadow: 0 24px 70px rgba(45, 55, 72, 0.15);
  overflow: hidden;
}

.auth-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(59, 130, 246, 0.02));
}

.brand {
  display: flex;
  gap: 12px;
  align-items: center;
}

.brand-logo {
  height: 44px;
  width: auto;
  border-radius: 10px;
  background: #eef2ff;
  padding: 6px;
}

.brand-kicker {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.2px;
  color: #2563eb;
}

.brand-name {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.auth-switch {
  display: inline-flex;
  background: #eef2ff;
  border: 1px solid rgba(12, 20, 39, 0.08);
  border-radius: 999px;
  padding: 4px;
  gap: 4px;
}

.auth-switch button {
  border: none;
  background: transparent;
  color: #1f2937;
  padding: 8px 16px;
  border-radius: 999px;
  font-weight: 600;
  transition: all 0.2s ease;
  cursor: pointer;
}

.auth-switch button.active {
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
  color: #0b1021;
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);
}

.auth-body {
  padding: 28px 22px 32px;
  display: grid;
  gap: 18px;
  background: #ffffff;
}

.auth-form {
  display: grid;
  gap: 14px;
}

.field {
  display: grid;
  gap: 6px;
}

.field span {
  font-size: 13px;
  color: #4b5563;
}

.field input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(12, 20, 39, 0.08);
  background: #f8fafc;
  color: #111827;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.field input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background: #ffffff;
}

.form-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.form-actions button {
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}

.form-actions button:active {
  transform: translateY(1px);
}

.form-actions button[disabled] {
  opacity: 0.4;
  cursor: not-allowed;
}

.form-actions button:not(.ghost) {
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
  color: #0b1021;
  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.28);
}

.form-actions .ghost {
  background: #f1f5f9;
  color: #1f2937;
  border: 1px solid rgba(12, 20, 39, 0.08);
}

.auth-divider {
  position: relative;
  text-align: center;
  color: #6b7280;
  font-size: 12px;
  letter-spacing: 0.4px;
}

.auth-divider::before,
.auth-divider::after {
  content: '';
  position: absolute;
  top: 50%;
  width: 36%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(12, 20, 39, 0.12));
}

.auth-divider::after {
  right: 0;
  transform: translateY(-50%) rotate(180deg);
}

.auth-divider::before {
  left: 0;
  transform: translateY(-50%);
}

.auth-inline {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 10px;
  align-items: center;
}

.auth-inline input {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(12, 20, 39, 0.08);
  background: #f8fafc;
  color: #111827;
}

.auth-inline button {
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(12, 20, 39, 0.08);
  background: #f1f5f9;
  color: #1f2937;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.auth-inline button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.google-btn-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 6px;
}

/* ===== Hivatalos Google Sign in Button CSS ===== */
.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: #fff;
  border: 1px solid #dfe1e5;
  border-radius: 14px;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 46px;
  letter-spacing: 0.2px;
  outline: none;
  overflow: hidden;
  padding: 0 14px;
  position: relative;
  text-align: center;
  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;
  white-space: nowrap;
  width: 100%;
  max-width: 320px;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: center;
  position: relative;
  width: 100%;
  gap: 10px;
}

.gsi-material-button .gsi-material-button-contents {
  flex-grow: 1;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
}

.gsi-material-button .gsi-material-button-state {
  transition: opacity 0.218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #f8f9fb;
  border-color: #dfe1e5;
}

.gsi-material-button:disabled .gsi-material-button-contents,
.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 0.45;
}

.gsi-material-button:not(:disabled):hover {
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.22);
  transform: translateY(-1px);
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state,
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

@media (max-width: 720px) {
  .auth-panel__header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .auth-inline {
    grid-template-columns: 1fr;
  }
  .form-actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./projects/admin/src/components/login/login.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gFAAgF;EAChF,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,uFAAuF;AACzF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wCAAwC;EACxC,oBAAoB;EACpB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,uEAAuE;AACzE;;AAEA;EACE,QAAQ;EACR,0CAA0C;AAC5C;;AAEA;EACE,OAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,2EAA2E;EAC3E,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,OAAO;EACP,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".auth-shell {\n  min-height: 100vh;\n  background: radial-gradient(120% 120% at 20% 20%, #f5f7fb, #e7ecf7 55%, #dfe6f5);\n  color: #1b2433;\n  display: grid;\n  place-items: center;\n  padding: 48px 16px;\n}\n\n.auth-hero {\n  text-align: center;\n  margin-bottom: 24px;\n  max-width: 720px;\n}\n\n.auth-hero__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.18);\n  color: #1d4ed8;\n  padding: 8px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n}\n\n.auth-hero__title {\n  margin: 12px 0 8px;\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.auth-hero__subtitle {\n  margin: 0;\n  color: #4b5563;\n  font-size: 15px;\n}\n\n.auth-panel {\n  width: min(960px, 100%);\n  background: #ffffff;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 24px 70px rgba(45, 55, 72, 0.15);\n  overflow: hidden;\n}\n\n.auth-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 22px;\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(59, 130, 246, 0.02));\n}\n\n.brand {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.brand-logo {\n  height: 44px;\n  width: auto;\n  border-radius: 10px;\n  background: #eef2ff;\n  padding: 6px;\n}\n\n.brand-kicker {\n  margin: 0;\n  font-size: 12px;\n  letter-spacing: 0.2px;\n  color: #2563eb;\n}\n\n.brand-name {\n  margin: 2px 0 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.auth-switch {\n  display: inline-flex;\n  background: #eef2ff;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  border-radius: 999px;\n  padding: 4px;\n  gap: 4px;\n}\n\n.auth-switch button {\n  border: none;\n  background: transparent;\n  color: #1f2937;\n  padding: 8px 16px;\n  border-radius: 999px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.auth-switch button.active {\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n  color: #0b1021;\n  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.3);\n}\n\n.auth-body {\n  padding: 28px 22px 32px;\n  display: grid;\n  gap: 18px;\n  background: #ffffff;\n}\n\n.auth-form {\n  display: grid;\n  gap: 14px;\n}\n\n.field {\n  display: grid;\n  gap: 6px;\n}\n\n.field span {\n  font-size: 13px;\n  color: #4b5563;\n}\n\n.field input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  background: #f8fafc;\n  color: #111827;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n\n.field input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n  background: #ffffff;\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.form-actions button {\n  border: none;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;\n}\n\n.form-actions button:active {\n  transform: translateY(1px);\n}\n\n.form-actions button[disabled] {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.form-actions button:not(.ghost) {\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n  color: #0b1021;\n  box-shadow: 0 12px 24px rgba(59, 130, 246, 0.28);\n}\n\n.form-actions .ghost {\n  background: #f1f5f9;\n  color: #1f2937;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n}\n\n.auth-divider {\n  position: relative;\n  text-align: center;\n  color: #6b7280;\n  font-size: 12px;\n  letter-spacing: 0.4px;\n}\n\n.auth-divider::before,\n.auth-divider::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  width: 36%;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, rgba(12, 20, 39, 0.12));\n}\n\n.auth-divider::after {\n  right: 0;\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.auth-divider::before {\n  left: 0;\n  transform: translateY(-50%);\n}\n\n.auth-inline {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.auth-inline input {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  background: #f8fafc;\n  color: #111827;\n}\n\n.auth-inline button {\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid rgba(12, 20, 39, 0.08);\n  background: #f1f5f9;\n  color: #1f2937;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.auth-inline button:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.google-btn-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 6px;\n}\n\n/* ===== Hivatalos Google Sign in Button CSS ===== */\n.gsi-material-button {\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  -webkit-appearance: none;\n  background-color: #fff;\n  border: 1px solid #dfe1e5;\n  border-radius: 14px;\n  box-sizing: border-box;\n  color: #1f1f1f;\n  cursor: pointer;\n  font-family: 'Roboto', arial, sans-serif;\n  font-size: 14px;\n  height: 46px;\n  letter-spacing: 0.2px;\n  outline: none;\n  overflow: hidden;\n  padding: 0 14px;\n  position: relative;\n  text-align: center;\n  transition: background-color 0.218s, border-color 0.218s, box-shadow 0.218s;\n  white-space: nowrap;\n  width: 100%;\n  max-width: 320px;\n}\n\n.gsi-material-button .gsi-material-button-icon {\n  height: 20px;\n  margin-right: 12px;\n  min-width: 20px;\n  width: 20px;\n}\n\n.gsi-material-button .gsi-material-button-content-wrapper {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  height: 100%;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  gap: 10px;\n}\n\n.gsi-material-button .gsi-material-button-contents {\n  flex-grow: 1;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.gsi-material-button .gsi-material-button-state {\n  transition: opacity 0.218s;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.gsi-material-button:disabled {\n  cursor: default;\n  background-color: #f8f9fb;\n  border-color: #dfe1e5;\n}\n\n.gsi-material-button:disabled .gsi-material-button-contents,\n.gsi-material-button:disabled .gsi-material-button-icon {\n  opacity: 0.45;\n}\n\n.gsi-material-button:not(:disabled):hover {\n  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.22);\n  transform: translateY(-1px);\n}\n\n.gsi-material-button:not(:disabled):active .gsi-material-button-state,\n.gsi-material-button:not(:disabled):focus .gsi-material-button-state {\n  background-color: #303030;\n  opacity: 12%;\n}\n\n@media (max-width: 720px) {\n  .auth-panel__header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n  .auth-inline {\n    grid-template-columns: 1fr;\n  }\n  .form-actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
